import { createTenantNetworkClient } from '@is24/tenant-network-fe';
import { getConfig } from '@/config';

export const tenantNetworkClient = createTenantNetworkClient({
  cdnBaseUrl: getConfig().tenantNetworkCdnUrl || 'https://tenant-network.sandbox-immobilienscout24.de/widget/v1',
});
